export default __webpack_public_path__ + "static/media/Sun-Only.fccd6d62.png";